import { Dialog, DialogContent, Grid, IconButton, styled } from "@mui/material";

export const StyledDialogContent = styled(DialogContent)({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  paddingTop: "10px",
});

export const Field = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  "&>.MuiButton-root": {
    color: theme.palette.primary.main,
    justifyContent: "flex-start",
    textTransform: "none",
  },
}));

export const DocumentViewerContainer = styled(Dialog)({
  overflow: "hidden",
  "& .MuiPaper-root": {
    maxWidth: "fit-content",
  },
});

export const ClearButton = styled(IconButton)({
  width: "20px",
  height: "20px",
  opacity: "0.3",
  "&:hover": {
    opacity: "1",
  },
});
